namespace Areas.Schedule {
    "use strict";

    var tabItems = Areas.createTabsWithSameController("Schedule",
        ["All", "CPOnly", "SubPhase"],"Main");


    export function scheduleTabInitialized(params: any) {
        return Areas.tabInitialized(tabItems)(params);
    }
}